import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createFormatters } from "locales/format";
import { toLanguage } from "locales/constants";

/** Formatters for the current language; callers re-render when it changes. */
export const useFormat = () => {
  const { t, i18n } = useTranslation();
  const language = toLanguage(i18n.language);

  return useMemo(
    () => createFormatters(language, (time) => t("time.yesterday", { time })),
    [language, t],
  );
};
